import { render, staticRenderFns } from "./TranslationsInterfaceTable.vue?vue&type=template&id=519a338c&"
import script from "./TranslationsInterfaceTable.vue?vue&type=script&lang=js&"
export * from "./TranslationsInterfaceTable.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsInterfaceTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports